<template>
  <FlexColumn>
    <FlexRow align="center">
      <Label text="気になる理由（最大3件）" class="label" />
      <FlexRow>
        <Chip
            v-for="reason in reasons"
            :key="`chat-request-form-reasons-${reason.value}`"
            size="m"
            link
            :color="reasonColor(reason)"
            @click="handleSelectReason(reason.value)"
        >
          {{reason.label}}
        </Chip>
      </FlexRow>
    </FlexRow>
<!--    <FlexRow align="center">-->
<!--      <Label text="もっと知りたい" class="label" />-->
<!--      <FlexRow>-->
<!--        <Chip-->
<!--            v-for="want in wants"-->
<!--            :key="`chat-request-form-wants-${want.value}`"-->
<!--            size="m"-->
<!--            link-->
<!--            :color="wantColor(want)"-->
<!--            @click="handleSelectWant(want.value)"-->
<!--        >-->
<!--          {{want.label}}-->
<!--        </Chip>-->
<!--      </FlexRow>-->
<!--    </FlexRow>-->
  </FlexColumn>
</template>


<script>
import FlexColumn from "@/components/atoms/FlexColumn";
import FlexRow from "@/components/atoms/FlexRow";
import Label from "@/components/atoms/Label";
import Chip from "@/components/atoms/Chip";
import {mapGetters} from "vuex";
import sortBy from 'lodash/sortBy'

const reasonOrders = {
  1: 3,
  2: 4,
  3: 1,
  4: 2,
  5: 5,
}

export default {
  name: "ChatRequestForm",
  components: {Chip, Label, FlexRow, FlexColumn},
  props: {
    applicant: {
      type: Object
    }
  },
  data() {
    return {
      selectReasons: [],
      selectWants: [],
    }
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    reasons() {
      return sortBy(this.consts.requestMotivation, [item => reasonOrders[item.value]])
    },
    wants() {
      return [
        {value: 1, label: '経験のあるデータ'},
        {value: 2, label: 'スキル'},
        {value: 3, label: '学歴'},
        {value: 4, label: '職歴'},
        {value: 5, label: '希望条件'},
      ]
    },
    selectedReasons() {
      if(this.applicant.chatRequest) {
        return this.applicant.chatRequest.reasons
      }
      return this.selectReasons
    },
    selectedWants() {
      if(this.applicant.chatRequest) {
        return this.applicant.chatRequest.wants
      }
      return this.selectWants
    },
    reasonColor() {
      return (reason) => {
        return this.selectedReasons.includes(reason.value) ? 'primary' : undefined
      }
    },
    wantColor() {
      return (want) => {
        return this.selectedWants.includes(want.value) ? 'primary' : undefined
      }
    }
  },
  methods: {
    handleSelectReason(value) {
      if (this.applicant.chatRequest != null) {
        return
      }
      if(this.selectReasons.includes(value)) {
        this.selectReasons = this.selectReasons.filter(reason => reason !== value)
      } else {
        if (this.selectReasons.length >= 3) {
          return
        }
        this.selectReasons.push(value)
      }
      this.$emit("change", {reasons: this.selectReasons})
    },
    handleSelectWant(value) {
      if(this.selectWants.includes(value)) {
        this.selectWants = this.selectWants.filter(want => want !== value)
      } else {
        this.selectWants.push(value)
      }
    }
  }
}
</script>

<style scoped>
.label {
  width: 172px;
}
</style>